import React, { useEffect, useState } from "react";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";
import { useNavigate } from 'react-router-dom'


export default function TambahMenu(){
  
      const navigate = useNavigate()

  const [categoriesTambah, setCategoriesTambah] = useState([]);
      const [formDataTambah, setFormDataTambah] = useState({
        name: "",
        category_id: "", // Store category_id instead of name
        description: "", // Store category_id instead of name
        admin_id: localStorage.getItem("UserAuthentication"),
      }); 
      
        const [loadingCategories, setLoadingCategories] = useState(false);
        const [categoriesError, setCategoriesError] = useState(null);

      useEffect(() => {
        const fetchCategories = async () => {
          try {
            setLoadingCategories(true);
            setCategoriesError(null);
            // Replace 'categories' with your actual API endpoint for categories
            const response = await instance2.get("dish_category");
            const apiCategories = response.data?.data || response.data || [];
            setCategoriesTambah(apiCategories);
          } catch (error) {
            console.error("Error fetching categories:", error);
            setCategoriesError(error.message || "Failed to fetch categories");
          } finally {
            setLoadingCategories(false);
          }
        };
      
        fetchCategories();
      }, []);

      const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Only apply transformation for the dish_name field.
        const transformedValue =
          name === "name"
            ? value
                .split(" ")
                .map((word) =>
                  word.length > 0
                    ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                    : ""
                )
                .join(" ")
            : value;
      
        setFormDataTambah((prev) => ({
          ...prev,
          [name]: transformedValue,
        })); 
      };
      
       const handleSubmitTambah = async (e) => {
          e.preventDefault(); // Prevent the default form submission behavior
        
          try {
            const response = await instance2.post("dishes", formDataTambah);
        
            console.log("Success:", response.data);
            navigate("/inputmenu")
            // Refresh the page after successful submission
            // navigate("/uploadresep", {
            //   state: {
            //     newDishId: response.data[0].id, // ID of newly created dish
            //     newDishName: formDataTambah.name, // Display name of the dish
            //   },
            // });
  // window.history.back(); // Goes to the previous page
          } catch (error) {
            console.error("Error:", error);
          }
        };

        const isFormValid = () => {
          return (
            formDataTambah.name.trim() !== "" &&
            formDataTambah.category_id !== "" 
            // formDataTambah.description.trim() !== ""
          );
        };
        

    return(
        <div className="p-4">
        <div className="flex flex-row gap-4 items-center">
          <div className="bg-white p-2 rounded-full cursor-pointer"
              onClick={() => window.history.back()}>
          <BackButton 
          className="rotate-180 text-black" />
          </div>
            <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Tambah Makanan</h1>
            </div>
        <div className="">
          <div className="flex flex-col justify-between items-center gap-10 pt-5 mx-5">
            <div className="flex flex-row items-center w-full gap-2">
            <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
              Nama Makanan
            </label>
            <input
              type="text"
              name="name"
              value={formDataTambah.name}
              onChange={handleChange}
              className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
              placeholder="Nama Makanan"
            />
            </div>
    
            <div className="flex flex-row items-center w-full gap-2">
            <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Kategori</label>
          <select
            className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
            value={formDataTambah.category_id}
            onChange={(e) => setFormDataTambah({ ...formDataTambah, category_id: e.target.value })}
          >
            <option value="" disabled>Pilih Kategori</option>
            {categoriesTambah.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name} {/* Assuming API returns 'id' and 'name' */}
              </option>
            ))}
          </select>
          </div>
    
    <div className="flex flex-row items-center w-full gap-2">
          <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Deskripsi</label>
          <textarea
            className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
            value={formDataTambah.description}
            onChange={(e) => setFormDataTambah({ ...formDataTambah, description: e.target.value })}
            placeholder="Tambahkan deskripsi resep..."
          />
          </div>
          </div>
      <div className="w-full flex flex-row sm:flex-row justify-center mt-4 px-4 sm:px-8 gap-5 pb-5">
        <button
        className="bg-merah-no py-5 px-8 text-white rounded-[30px] hover:bg-merah-hover"
          onClick={() => {window.history.back()}}
        >
          Kembali
        </button>
        <button
          onClick={handleSubmitTambah}
              disabled={!isFormValid()}
              className={`py-5 px-8 rounded-[30px] text-sm transition-colors duration-300 ${
                isFormValid()
                  ? "bg-merah-no text-white hover:bg-merah-hover"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
        >
          Simpan
        </button>
      </div>
      </div>
        </div>
    )
}